import { render } from "./Footer.vue?vue&type=template&id=3d779054"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=3d779054&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__